import { post } from "@/api/request"

// 艺术家主页
export const getArtistHome = params => post("/wap/artisthome/index", params)
